module.exports = __webpack_public_path__ + "img/shop-walmart.a6cc483a.png";